import {RegionService, MovieMetaService, MovieService, OrderService} from 'hasta-la-vista-middleware-api/service'
import {Utils} from 'hasta-la-vista-ui-core'
import moment from 'moment'
import Vue from 'vue'

export default {
    props: {
        search_filter: [],
        filters: Object,
        filter: Object,
        doSearch: Boolean,
        activeMovie: Object,
    },

    data() {
        return {
            hasOpened: false,
            movies: undefined,
            loading: false,
            openForm: (this.$breakpoints.smDown ? false : true),
            selected_movie: null,
            lastSelected: null,
            movie_selected_here: false,
            cinema_slected_here: false,
            cinemasNearBy: [],
            place: null,
            selected_cinema_id: '',
            selected_cinema: '',
            selected_cinema_type: null,
            movieCinemas: [],
            form_data: {
                place_query: null,
                keyword: null,
                selected_cinema: null,
                genres: null,
                cinema_types: null,
                filter_group: {
                    genres: null,
                    cinema_types: null,
                },
                selected_time_range: null,
            },
            search: 'sandton',
            regions: [],
            cinemaType: [],
            allCinemaTypes: [],
            all_movies: [],
            selected_date: '',
            selected_time: null,
            isActive: this.$breakpoints.smDown ? false : true,
            times: [],
            elm: null,
            timer: null,
            covidConfirm: false,
            redirectCinemas: [],
        }
    },

    computed: {
        filterVals() {
            let genre_ids = [];
            let collection = {genre_ids: [], experiences: []}
            if(this.form_data.genres) {
                for(let g in this.form_data.genres) {
                    // console.log(this.form_data.filter_group.genres[g])
                    collection.genre_ids.push(this.form_data.genres[g].id)
                }
            }

            if(this.form_data.cinema_types) {
                for(let c in this.form_data.cinema_types) {
                    // console.log(this.form_data.filter_group.cinema_types[c])
                    collection.experiences.push(this.form_data.cinema_types[c].name)
                }
            }
            var cineams = undefined;
            if (this.form_data.selected_cinema && this.form_data.selected_cinema.id) {
                var cinemas = this.form_data.selected_cinema.id

                if(this.redirectCinemas.includes(this.form_data.selected_cinema.id)) {
                  window.location.href="https://movies.sterkinekor.com/actual-content?tab=now-showing"
                }
            }

            // console.log(collection.experiences)

            return {
                title: undefined,
                cinemas: cinemas,
                genres: collection.genre_ids || undefined,
                experiences: collection.experiences || undefined,
                time_range: this.form_data.selected_time_range || undefined
            }
        },

        classes() {
            return {
                'quick-book': true,
                'quick-book--open': this.isActive
            }
        },

        cinemasByRegion(){
            var allowedCinemas = this.selected_movie ? Object.keys(this.selected_movie.cinemas) : this.movieCinemas;

            var allowedRegions = this.regions.map((r)=> {
                if(this.redirectCinemas !== undefined) {
                  for (let i = 0; i < this.redirectCinemas.length; i++) {
                    allowedCinemas.push(this.redirectCinemas[i])
                  }
                }
                let cinemas = r.cinemas.filter((c)=>~allowedCinemas.indexOf(c.id.toString()) || allowedCinemas.length ==0);
                return {
                    id:r.id,
                    name:r.name,
                    cinemas
                };
            }).filter((r)=>r.cinemas.length > 0)

            return [{name: 'Nearby', cinemas: this.cinemasNearBy}].concat(allowedRegions)//.concat(this.regions)
        },

        cinema() {
            return this.form_data.selected_cinema
        },

        cinema_type(){
            var default_cinema_type = null;
            // auto select the appropriate cinema type for a movie.
            if (this.selected_movie /*&& this.selected_movie.experiences.length == 1*/) default_cinema_type = this.selected_movie.experiences[0]
            return this.selected_cinema_type || default_cinema_type

        },

        sessions(){
            return this.selected_movie && this.cinema && this.cinema.id && this.selected_movie.cinemas[this.cinema.id] ? this.selected_movie.cinemas[this.cinema.id].filter((s)=>(~s.experiences.findIndex((e)=>e.name == this.cinema_type || !this.cinema_type)) && !s.show_time.additional.is_passed) : [];
        },

        availableDates(){
            var availableDates = this.sessions.reduce((c, session)=> {
                var obj = {
                    string: `${session.show_time.additional.string_short_day_of_week}, ${session.show_time.additional.string_nth_day} ${session.show_time.additional.string_short_month}`,
                    show_time: session.show_time
                };
                !(~c.findIndex((c)=>c.string === obj.string)) && c.push(obj);
                // if (c.length == 1) this.setSelectedDate(c[0].show_time.date)

                return c;
            }, [])
            if (!this.selected_date) this.selected_date = availableDates[0];

            return availableDates
        },

        availableSessions(){
            var availableSessions = this.sessions.filter((session)=>session.show_time.date.format('YYYY-MM-DD') === this.selected_date.show_time.date.format('YYYY-MM-DD')).map((s)=> {
                s.time = s.show_time.additional.no_zero_hour_24 + ':' + s.show_time.additional.minute;
                return s;
            });
            if (!this.selected_time) this.selected_time = availableSessions[0];

            return availableSessions;
        },

        cinemaExperiences(){
            return (this.selected_movie &&  this.form_data.selected_cinema)  ? this.selected_movie.getExperienceForCinema( this.form_data.selected_cinema.id) : [];
        },

        canBook() {
            return true;
        }
    },

    created () {
        Promise.all([RegionService.getRegions(), this.filterMovies(), RegionService.getRedirectCinemas()])
            .then(([regions, filtered, redirectCinemas])=> {
                //         // this.cinemaType = meta.experiences
                //         // this.allCinemaTypes = this.cinemaType
                this.redirectCinemas = redirectCinemas.data
                this.regions = regions.data
                //
                if (this.activeMovie) {
                    this.selected_movie = this.activeMovie
                }
                Vue.nextTick(()=>{
                    this.startAutoClose()
                })
            })
    },

    mounted() {
        Object.assign(this.form_data, this.filters);

    },

    methods: {
        filterMovies(){
            return MovieService.getFilteredMovies(this.filterVals).then((movies)=> {
                this.lastSelected = this.movie_selected_here ? this.selected_movie : undefined;
                this.movies = movies.byHasSessions()
                this.movieCinemas = movies.getCinemaIds();
                this.selected_movie = this.lastSelected || this.selected_movie;
            });
        },

        toggleForm() {
            this.isActive = !this.isActive;
        },

        startAutoClose() {
            if (!this.$breakpoints.smDown) {
                this.elm = this.$el
                this.elm.addEventListener('mousedown', this.stopAutoClose)
                this.timer = window.setTimeout(this.toggleForm, 8000)
            }
        },

        stopAutoClose() {
            window.clearTimeout(this.timer)
            window.removeEventListener('mousedown', this.elm)
        },

        toggleCinemaType(el, experience) {
            //     var current_selected_cinema_types = this.selected_cinema_types;
            //
            //     this.times = []
            //     this.selected_date = null
            //     this.selected_time = null
            //
            //     // console.log("Reset Times", this.times)
            //
            //     if (this.activeLabel) {
            //         this.activeLabel = false
            //
            //         var add_to_experiences = true;
            //         this.selected_cinema_types = []
            //
            //         for (var i = 0; i < current_selected_cinema_types.length; i++) {
            //             add_to_experiences = true;
            //
            //             for (var k = 0; k < current_selected_cinema_types.length; k++) {
            //                 if (experience == current_selected_cinema_types[k].name) {
            //                     add_to_experiences = false
            //
            //                 }
            //             }
            //
            //             if (add_to_experiences) {
            //                 this.selected_cinema_types.push({name: experience})
            //             }
            //         }
            //
            //         // console.log("Select Cinema Type", this.selected_movie, this.selected_cinema_types)
            //
            //     } else {
            //         this.activeLabel = true
            //         if (this.selected_cinema_types.length == 0) {
            //             this.selected_cinema_types.push({name: experience})
            //         } else {
            //             this.selected_cinema_types = []
            //             this.selected_cinema_types.push({name: experience})
            //             for (var i = 0; i < current_selected_cinema_types.length; i++) {
            //                 if (experience != current_selected_cinema_types[i].name) {
            //                     this.selected_cinema_types.push({name: experience})
            //                 }
            //             }
            //         }
            //
            //         // console.log("Select Cinema Type", this.selected_movie, this.selected_cinema_types)
            //         if (this.selected_movie && this.selected_cinema_types.length > 0) {
            //             // console.log("before getSession ", this.selected_movie, this.selected_cinema_types)
            //             this.getSessions()
            //         }
            //     }
            //
            //
        },

        // getClosestCinema () {
        //
        //     RegionService.getCinemasNearBy(this.place.latitude, this.place.longitude).then((cinemasNearBy)=> {
        //
        //             cinemasNearBy.length = 5; //restrict number of results to 5;
        //
        //             this.cinemasNearBy = cinemasNearBy;
        //
        //         }
        //     )
        // },

        //
        // getFilteredMovies(filter) {
        //
        //     return MovieService.getFilteredMovies(filter)
        //         .then((movies) => {
        //             this.movies = movies.byRelease();
        //             this.selected_cinema_id = filter.cinemas
        //         })
        // },

        // getSessions() {
        //
        //     // return this.selected_movie.session
        //     // Promise.resolve(MovieService.getSessions(this.selected_movie.id, this.form_data.selected_cinema.id)).then((sessions) => {
        //     //     var sessionsData = sessions.data
        //     //     var session_data = [];
        //     //     if (sessions.success) {
        //     //         var unique_dates = []
        //     //         // console.log("before session ", sessionsData)
        //     //         for (var i = 0; i < sessionsData[this.form_data.selected_cinema.id].length; i++) {
        //     //             // console.log("Session Data", sessionsData[this.form_data.selected_cinema.id][i])
        //     //             // console.log("Ex", sessionsData[this.form_data.selected_cinema.id][i].experiences)
        //     //
        //     //             for (var k = 0; k < sessionsData[this.form_data.selected_cinema.id][i].experiences.length; k++) {
        //     //                 var data = {
        //     //                     id: sessionsData[this.form_data.selected_cinema.id][i].id,
        //     //                     experience: sessionsData[this.form_data.selected_cinema.id][i].experiences[k],
        //     //                     date: moment(sessionsData[this.form_data.selected_cinema.id][i].show_time_date).format('dd, DD MMM YYYY'),
        //     //                     time: sessionsData[this.form_data.selected_cinema.id][i].show_time_time,
        //     //                     screen_name: sessionsData[this.form_data.selected_cinema.id][i].screen_name,
        //     //                     movie_id: sessionsData[this.form_data.selected_cinema.id][i].movie_id
        //     //                 }
        //     //                 session_data.push(data)
        //     //
        //     //                 if (unique_dates.length == 0) {
        //     //                     unique_dates.push(moment(sessionsData[this.form_data.selected_cinema.id][i].show_time_date).format('dd, DD MMM YYYY'))
        //     //                 }
        //     //                 var add_to_unique_dates = true;
        //     //
        //     //                 for (var d = 0; d < unique_dates.length; d++) {
        //     //
        //     //                     if (unique_dates[d] == moment(sessionsData[this.form_data.selected_cinema.id][i].show_time_date).format('dd, DD MMM YYYY')) {
        //     //                         add_to_unique_dates = false;
        //     //                     }
        //     //                 }
        //     //
        //     //                 if (add_to_unique_dates) {
        //     //                     unique_dates.push(moment(sessionsData[this.form_data.selected_cinema.id][i].show_time_date).format('dd, DD MMM YYYY'))
        //     //                 }
        //     //             }
        //     //         }
        //     //     }
        //     //
        //     //     this.sessions = {session_data: session_data, unique_dates: unique_dates}
        //     // });
        //
        // },

        startOrder(){
            this.loading = true
            window.scroll({top: 0, left: 0})
            OrderService.newOrder(this.selected_time.id, this.cinema.id, this.selected_movie.id).then((order)=> {
                this.$router.push(`/booking/1`)
            });
        },
    },

    watch: {
        activeMovie(){
            //this peice of code will open the quick book when the user selects a movie on the homepage. but only once.

            if (!this.hasOpened && this.form_data.selected_cinema && !this.$breakpoints.smDown) {
                this.isActive = true;
                this.hasOpened = true;
            }
            if ((!this.movie_selected_here || !this.selected_movie) && this.activeMovie) {
                this.movie_selected_here = false;
                // console.log("setting active movie", this.activeMovie)
                this.selected_movie = this.activeMovie;
            }

        },
        form_data: {
            handler() {
                this.filterMovies();
                this.selected_date = undefined;
                this.selected_time = undefined;
            },
            deep: true
        },
        filters: {
            handler: function () {
                if (!this.cinema_selected_here || !this.form_data.selected_cinema) {
                    this.cinema_selected_here = false;
                    this.form_data.selected_cinema = this.filters.selected_cinema

                }


            },
            deep: true
        },
        selected_movie(){
            this.selected_date = undefined;
            this.selected_time = undefined;
        },

        selected_date() {
            this.selected_time = undefined;
        }

    }
}



// WEBPACK FOOTER //
// ./src/components/booking/quick-book/quick-book.js